export enum ClientFields {
  Civilite = "CivilityTypeId",
  LastName = "LastName",
  FirstName = "FirstName",
  BirthCity = "BirthCity",
  BirthCountry = "BirthCountryId",
  Nationality = "NationalityCountryId",
  BirthZipCode = "BirthZipCode",
  BirthDate = "BirthDate",
  Address1 = "Address1",
  Address2 = "Address2",
  ZipCode = "ZipCode",
  City = "City",
  Email = "Email",
  PhoneNumber = "PhoneNumber",
  PhonePrefix = "PhonePrefix",
  IsEnrolled = "isEnrolled",
  IsDematerializationPreferred = "IsDematerializationPreferred",
  IsEmailConsents = "IsEmailConsents",
  IsSmsConsents = "IsSmsconsents",
  FirstDistributorId = "FirstDistributorId",
  CreationDateFirstPolicy = "CreationDateFirstPolicy",
  GdaTypeId = "GdaTypeId",
  Gdareason = "Gdareason",
  IsPpe = "IsPpe",
}
